var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        { staticClass: "row my-3" },
        _vm._l(_vm.orderBumps, function (bump) {
          return _c("OrderBump", { key: bump.id, attrs: { bump: bump } })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }